import Vue from 'vue'
import Vuex from 'vuex'

import viewer from './modules/viewer'
import loader from './modules/loader'
import search from './modules/search'
import refiner from './modules/refiner'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    loader,
    viewer,
    search,
    refiner
  }
})
